import { render, staticRenderFns } from "./waitorder.vue?vue&type=template&id=5f734b37&scoped=true&"
import script from "./waitorder.vue?vue&type=script&lang=js&"
export * from "./waitorder.vue?vue&type=script&lang=js&"
import style0 from "./waitorder.vue?vue&type=style&index=0&id=5f734b37&lang=less&scoped=true&"
import style1 from "./waitorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f734b37",
  null
  
)

export default component.exports